/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Section } from '../Shared/Section'
import { CheckoutSystemCard } from './Cards/CheckoutSystemCard/CheckoutSystemCard'
import { DevicesCard } from './Cards/DevicesCard/DevicesCard'
import { ImportStockCard } from './Cards/ImportStockCard/ImportStockCard'
import { SectionHeader } from '../Shared/SectionHeader'
import { IntegrationStateCards } from './Cards/IntegrationStateCards/IntegrationStateCards'
import { useTranslation } from 'react-i18next'

const IntegrationSection = () => {
    const [t] = useTranslation()

    return (
      <>
          <SectionHeader title={t('dashboard.integrations')} />

          <Section>
              <div
                css={css`
                    display: flex;
                    gap: 1rem;
                    justify-content: center;
                    flex-wrap: wrap;
                    width: 100%;
                `}
              >
                  <IntegrationStateCards />
              </div>
              <ImportStockCard/>
              <CheckoutSystemCard/>
              <DevicesCard/>
          </Section>
      </>
    )
}

export { IntegrationSection }
